// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"07267f58","59":"a0d2eab6","361":"e2e42ca7","574":"9fbe9fb9","583":"40fdbc8f","661":"6929481f","757":"7cb14748"}[chunkId] + ".chunk.js";
};